import type { MaintenanceAlertStatus } from "@/lib/adminFleetApi";

/** Converte uma data ISO `yyyy-MM-dd` (ou ISO completa) para o formato brasileiro `DD/MM/AAAA`. */
export function formatBrDate(value?: string | null): string {
  if (!value) return "—";
  const datePart = value.slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!match) return value;
  return `${match[3]}/${match[2]}/${match[1]}`;
}

/** Data de hoje no fuso local, como `yyyy-MM-dd` (para preencher inputs de data). */
export function todayIso(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function formatKm(value?: number | null): string {
  if (value == null) return "—";
  return `${value.toLocaleString("pt-BR")} km`;
}

export const ALERT_LABELS: Record<MaintenanceAlertStatus, string> = {
  EM_DIA: "Em dia",
  PROXIMA: "Próxima",
  VENCIDA: "Vencida",
};

export const ALERT_EMOJI: Record<MaintenanceAlertStatus, string> = {
  EM_DIA: "🟢",
  PROXIMA: "🟡",
  VENCIDA: "🔴",
};

/** Classes de cor (Tailwind) coerentes com o design system para cada situação. */
export const ALERT_BADGE_CLASSES: Record<MaintenanceAlertStatus, string> = {
  EM_DIA: "bg-emerald-100 text-emerald-800 border-emerald-200",
  PROXIMA: "bg-amber-100 text-amber-800 border-amber-200",
  VENCIDA: "bg-red-100 text-red-800 border-red-200",
};
